module.exports = __webpack_public_path__ + "img/chevron-up.2eab8223.svg";